import React, { useEffect, useState } from 'react';
import api from '../services/api';

export const fmtDatum = (d) => d ? new Date(d).toLocaleString('nl-NL', { day: 'numeric', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit' }) : '—';

export async function openMetingPdf(id) {
  const venster = window.open('', '_blank');
  try {
    const r = await api.get(`/metingen/${id}/pdf`, { responseType: 'blob' });
    const url = URL.createObjectURL(new Blob([r.data], { type: 'application/pdf' }));
    if (venster) venster.location.href = url; else window.location.href = url;
  } catch (e) {
    if (venster) venster.close();
    alert('PDF openen mislukt');
  }
}

export function MetingStatus({ status }) {
  const s = {
    concept: { t: 'Concept', bg: '#fef3c7', c: '#92400e' },
    verstuurd: { t: 'Nieuw', bg: '#dbeafe', c: '#1e40af' },
    verwerkt: { t: 'Verwerkt', bg: '#dcfce7', c: '#166534' }
  }[status] || { t: status, bg: '#f1f5f9', c: '#475569' };
  return <span style={{ fontSize: 11, fontWeight: 700, padding: '3px 9px', borderRadius: 999, background: s.bg, color: s.c, whiteSpace: 'nowrap' }}>{s.t}</span>;
}

const KEUZE_TXT = { goed: 'Goed', fout: 'Fout', nvt: 'N.v.t.', aanwezig: 'Aanwezig', afwezig: 'Niet aanwezig' };

// Read-only weergave van een inzending (snapshot + data)
export function MetingInhoud({ inzending }) {
  const snap = inzending.template_snapshot || { secties: [] };
  const data = inzending.data || { secties: {} };
  const kleur = snap.kleur || '#1e40af';
  const tekst = (item, v) => {
    if (!v) return '—';
    if (item.type === 'checkbox') return v.waarde === true || v.waarde === 'true' ? 'Ja' : '—';
    if (KEUZE_TXT[v.waarde]) return KEUZE_TXT[v.waarde] + (v.extra ? ' · IP ' + v.extra : '');
    if (v.waarde === '' || v.waarde == null) return '—';
    return String(v.waarde) + (item.eenheid && item.type !== 'dropdown' ? ' ' + item.eenheid : '');
  };
  return (
    <div>
      {snap.secties.map(sec => (data.secties[sec.id] || []).map((inst, idx) => (
        <div key={sec.id + '-' + idx} style={{ border: '1px solid #e5e7eb', borderRadius: 8, marginBottom: 10, overflow: 'hidden' }}>
          <div style={{ background: kleur, color: '#fff', padding: '7px 12px', fontWeight: 600, fontSize: 13 }}>
            {sec.naam}{sec.aanpasbaar ? ' ' + (idx + 1) : ''}{inst.naam ? ' — ' + inst.naam : ''}
          </div>
          <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
            <tbody>
              {sec.items.map(item => {
                const v = (inst.waarden || {})[item.id];
                const fout = v && v.waarde === 'fout';
                return (
                  <tr key={item.id} style={{ borderTop: '1px solid #f1f5f9' }}>
                    <td style={{ padding: '6px 12px', color: '#4b5563', width: '50%' }}>{item.label}</td>
                    <td style={{ padding: '6px 12px', fontWeight: 600, color: fout ? '#dc2626' : '#111827' }}>
                      {item.type === 'handtekening' && v && v.waarde ? <img src={v.waarde} alt="" style={{ maxHeight: 50 }} /> : tekst(item, v)}
                      {v && v.opmerking && <div style={{ fontWeight: 400, fontSize: 12, color: '#6b7280' }}>💬 {v.opmerking}</div>}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )))}
      {inzending.handtekening_data && (
        <div style={{ marginTop: 6 }}>
          <div style={{ fontSize: 12, color: '#6b7280' }}>Handtekening{inzending.handtekening_naam ? ' — ' + inzending.handtekening_naam : ''}</div>
          <img src={inzending.handtekening_data} alt="handtekening" style={{ maxWidth: 220, border: '1px solid #e5e7eb', borderRadius: 6 }} />
        </div>
      )}
    </div>
  );
}

// Compacte lijst voor werkorder- en projectdetail
export default function MetingenLijst({ werkorderId, projectId }) {
  const [lijst, setLijst] = useState(null);
  const [open, setOpen] = useState(null);
  const [detail, setDetail] = useState(null);

  useEffect(() => {
    const url = werkorderId ? `/metingen/werkorder/${werkorderId}` : projectId ? `/metingen/project/${projectId}` : null;
    if (!url) return;
    api.get(url).then(r => setLijst(r.data.inzendingen || [])).catch(() => setLijst([]));
  }, [werkorderId, projectId]);

  const toggle = async (id) => {
    if (open === id) { setOpen(null); return; }
    setOpen(id); setDetail(null);
    try { const r = await api.get(`/metingen/${id}`); setDetail(r.data.inzending); } catch (e) { setDetail(false); }
  };

  if (!lijst || lijst.length === 0) return null;

  return (
    <div style={{ marginTop: 16 }}>
      <h4 style={{ margin: '0 0 8px', fontSize: 15 }}>📐 Metingen ({lijst.length})</h4>
      {lijst.map(m => (
        <div key={m.id} style={{ border: '1px solid #e5e7eb', borderRadius: 8, marginBottom: 6, background: '#fff' }}>
          <div onClick={() => toggle(m.id)} style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '9px 12px', cursor: 'pointer' }}>
            <span>{m.soort === 'afname' ? '✅' : '📐'}</span>
            <span style={{ flex: 1, fontSize: 14 }}>
              <strong>{m.template_naam}</strong>
              <span style={{ color: '#6b7280' }}> · {m.monteur_naam} · {fmtDatum(m.verstuurd_op)}{projectId && m.ordernummer ? ' · ' + m.ordernummer : ''}</span>
            </span>
            <MetingStatus status={m.status} />
            <button onClick={(e) => { e.stopPropagation(); openMetingPdf(m.id); }}
              style={{ padding: '4px 10px', borderRadius: 6, border: '1px solid #d1d5db', background: '#f9fafb', cursor: 'pointer', fontSize: 12 }}>PDF</button>
          </div>
          {open === m.id && (
            <div style={{ padding: '4px 12px 12px' }}>
              {detail === null ? 'Laden…' : detail === false ? 'Kon niet laden' : <MetingInhoud inzending={detail} />}
            </div>
          )}
        </div>
      ))}
    </div>
  );
}
